module.exports = __webpack_public_path__ + "static/img/login-background-ERP.a4e1f74d.png";